import React from 'react';
import PropTypes from 'prop-types';
import { formatAmount } from '../../utils/amountUtils';
import Currency from './Currency';
import AmountType from './AmountType';

function AmountSetup({ application, formValues, change }) {
  const { receivableCurrency } = application;

  const getValue = (key) => {
    return formValues[key];
  };

  const receiverCurrency = getValue('receiverCurrency');
  const amountType = getValue('amountType');

  const handleAmountFormatChange = (event, currency) => {
    if (getValue('amountValue')) {
      const value = getValue('amountValue');
      const formattedAmount = formatAmount(value, currency);
      change('amountValue', formattedAmount);
    }

    if (
      getValue('merchantAmount1') ||
      getValue('merchantAmount2') ||
      getValue('merchantAmount3')
    ) {
      const merchantAmount1 = getValue('merchantAmount1');
      const formattedAmount1 = formatAmount(merchantAmount1, currency);
      change('merchantAmount1', formattedAmount1);

      const merchantAmount2 = getValue('merchantAmount2');
      const formattedAmount2 = formatAmount(merchantAmount2, currency);
      change('merchantAmount2', formattedAmount2);

      const merchantAmount3 = getValue('merchantAmount3');
      const formattedAmount3 = formatAmount(merchantAmount3, currency);
      change('merchantAmount3', formattedAmount3);
    }
  };

  const handleAmountTypeChange = () => {
    change('amountValue', '');
    change('merchantAmount1', '');
    change('merchantAmount2', '');
    change('merchantAmount3', '');
  };

  return (
    <div className="amount-setup">
      <Currency
        receivableCurrency={receivableCurrency}
        handleAmountFormatChange={handleAmountFormatChange}
      />
      <AmountType
        receiverCurrency={receiverCurrency}
        amountType={amountType}
        handleAmountTypeChange={handleAmountTypeChange}
      />
    </div>
  );
}

AmountSetup.propTypes = {
  application: PropTypes.object,
  formValues: PropTypes.object,
  change: PropTypes.func,
};

export default AmountSetup;
